module.exports = __webpack_public_path__ + "static/img/HappeningsEventsSituations-review-3May1960.67965f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/HappeningsEventsSituations-review-3May1960.jpg
// module id = TUtN
// module chunks = 0